var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"u-fade"}},[(_vm.isOpen)?_c('modal-content',{on:{"close":function($event){return _vm.$emit('close')}}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }